var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F0F8FECF-A633-49E6-8060-D9277B9A8501@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_WIP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post_processing_page_delivery",
    transform: "translate(-21.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "highlight_alt_black_24dp",
    transform: "translate(21.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,5 L15,5 L15,3 L17,3 L17,5 Z M15,15 L15,21 L17.29,18.71 L19.59,21 L21,19.59 L18.71,17.3 L21,15 L15,15 Z M19,9 L21,9 L21,7 L19,7 L19,9 Z M19,13 L21,13 L21,11 L19,11 L19,13 Z M11,21 L13,21 L13,19 L11,19 L11,21 Z M7,5 L9,5 L9,3 L7,3 L7,5 Z M3,17 L5,17 L5,15 L3,15 L3,17 Z M5,21 L5,19 L3,19 C3,20.1 3.9,21 5,21 Z M19,3 L19,5 L21,5 C21,3.9 20.1,3 19,3 Z M11,5 L13,5 L13,3 L11,3 L11,5 Z M3,9 L5,9 L5,7 L3,7 L3,9 Z M7,21 L9,21 L9,19 L7,19 L7,21 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M3,5 L5,5 L5,3 C3.9,3 3,3.9 3,5 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.b7fb5d95feebb598bc660d1893315c26.svg";
export { ForwardRef as ReactComponent };